import { ItinerantRegisterTemplate } from "../../Templates/ItinerantRegisterTemplate";

export const ItinerantRegister = () => {
  return <ItinerantRegisterTemplate />;
};
